'use strict';

function isApiEntity(entity) {
  return entity.kind.toLocaleUpperCase("en-US") === "API";
}
function isComponentEntity(entity) {
  return entity.kind.toLocaleUpperCase("en-US") === "COMPONENT";
}
function isDomainEntity(entity) {
  return entity.kind.toLocaleUpperCase("en-US") === "DOMAIN";
}
function isGroupEntity(entity) {
  return entity.kind.toLocaleUpperCase("en-US") === "GROUP";
}
function isLocationEntity(entity) {
  return entity.kind.toLocaleUpperCase("en-US") === "LOCATION";
}
function isResourceEntity(entity) {
  return entity.kind.toLocaleUpperCase("en-US") === "RESOURCE";
}
function isSystemEntity(entity) {
  return entity.kind.toLocaleUpperCase("en-US") === "SYSTEM";
}
function isUserEntity(entity) {
  return entity.kind.toLocaleUpperCase("en-US") === "USER";
}

exports.isApiEntity = isApiEntity;
exports.isComponentEntity = isComponentEntity;
exports.isDomainEntity = isDomainEntity;
exports.isGroupEntity = isGroupEntity;
exports.isLocationEntity = isLocationEntity;
exports.isResourceEntity = isResourceEntity;
exports.isSystemEntity = isSystemEntity;
exports.isUserEntity = isUserEntity;
//# sourceMappingURL=conditions.cjs.js.map
